export const GA_PROMOTION_CLICK_KEY = 'promoClick';
export const GA_PROMOTION_VIEW_KEY = 'promoView';
export const GA_EMAIL_PROMOTION_ID = 'promo_id';
export const GA_EMAIL_PROMOTION_NAME = 'promo_name';
export const GA_EMAIL_PROMOTION_POSITION = 'promo_position';
export const GA_EMAIL_PROMOTION_CREATIVE = 'promo_creative';
